var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items && _vm.items.length)?_c('ul',{class:_vm.listingsClasses},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,staticClass:"listings-item"},[_c('listing',_vm._b({},'listing',item,false))],1)})):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }